import { CellPosition } from "../../../internal/types";

export function formatCellPositionString(cellPosition: CellPosition): string {
  return `${cellPosition.rowIndex},${cellPosition.columnIndex}`;
}

/**
 * Checks if two cell positions are equal.
 */
export function areCellPositionsEqual(
  pos1: CellPosition | null | undefined,
  pos2: CellPosition | null | undefined,
): boolean {
  if (!pos1 || !pos2) return false;
  return (
    pos1.rowIndex === pos2.rowIndex && pos1.columnIndex === pos2.columnIndex
  );
}
